const CONTACT_MODAL = 'CONTACT_MODAL'
const SENT_MODAL = 'SENT_MODAL'

export const modalNames = {
    CONTACT_MODAL,
    SENT_MODAL,
}
